export { default } from '@/components/Pages/BusinessPage';
